import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
/**
 * Used stand-alone to wrap a format function and create a "formatter" from it. Also used as a
 * base class to mimic Intl formatters' behavior, which allow calling `format` without context.
 * See the spec for more details: {@link https://tc39.es/ecma402/#sec-intl.numberformat.prototype.format}.
 */ export var BoundFormat = function BoundFormat(format) {
    "use strict";
    _class_call_check(this, BoundFormat);
    Object.defineProperty(this, "format", {
        value: format
    });
};
export var toFormat = function(format) {
    return typeof format === "function" ? new BoundFormat(format) : format;
};

//# sourceMappingURL=BoundFormat.js.map